<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'customerManage-custAudit',
  components: { PageTable },
}
</script>
